import { SendNewFormsAndDocumentsInterface } from '../../../../../../../models/SendNewFormsAndDocumentsInterface';

const getFormI18nNamespace = (form: SendNewFormsAndDocumentsInterface | null | undefined): string => {
  const version = form?.version ?? 'v1';
  return `${form?.formComponent}-${version}`;
};

export default getFormI18nNamespace;
